import { getAccessToken } from 'AccessToken';

let tabRef = null;

export const Navigate_AI_Assistant = () => {
  const user = JSON.parse(localStorage.getItem('loggedInUser'));
  const final_url = `https://ai-assistant.ifca.asia/#/ai/ai-assistant/ContractX-Assistant`;

  // If the tab is already open and not closed
  if (tabRef && !tabRef.closed) {
    tabRef.focus(); // Focus it without reloading
  } else {
    // Open a new tab and save the reference
    tabRef = window.open(final_url, '_blank');
  }

  let sendcount = 0;
  const timer = setInterval(() => {
    if (tabRef.current.closed) {
      clearInterval(timer);
      return;
    }

    if (sendcount > 2) {
      /// stop to post user to Ai Assistant after failed 3 times
      clearInterval(timer);
    }

    let accesstoken = getAccessToken();
    let name = user?.name;

    try {
      tabRef.current?.postMessage(
        {
          accessToken_: accesstoken,
          userName_: name,
          appCode_: 'hrx-test',
          avatarUrl_:
            localStorage.getItem('UserProfilePic') ||
            'https://static.thenounproject.com/png/1071790-200.png',
          product_: 'ContractX',
        },
        final_url, //origin
      );
      clearInterval(timer);
    } catch (e) {}

    sendcount++;
  }, 2000);
};
